var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("TabelToolBar", {
            ref: "TabelToolBar",
            on: {
              onSave_OuterBoxLabelManagement:
                _vm.onSave_OuterBoxLabelManagement,
              onSelectOrder_OuterBoxLabelManagement:
                _vm.onSelectOrder_OuterBoxLabelManagement,
              onCreateOutBoxBarcode_OuterBoxLabelManagement:
                _vm.onCreateOutBoxBarcode_OuterBoxLabelManagement,
              onPrintOuterBoxLabel_OuterBoxLabelManagement:
                _vm.onPrintOuterBoxLabel_OuterBoxLabelManagement,
              getBackOrder: _vm.getBackOrder,
              nextOrder: _vm.nextOrder,
              onHandleDetailExport: _vm.onHandleDetailExport
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "OuterBoxLabelManagement-Edit" },
        [
          _vm.isShowTabelHeader
            ? _c("TabelHeader", {
                ref: "TabelHeader",
                on: { cbID: _vm.cbID, cbNextOrder: _vm.cbNextOrder }
              })
            : _vm._e(),
          _c("EditTable", {
            ref: "EditTable",
            on: {
              onDialogSubmit_OuterBoxLabelManagement:
                _vm.onDialogSubmit_OuterBoxLabelManagement
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }